import { parseImgUrl, setImgStyle } from 'src/filter/modules/img.js';

export function setArray(array, max, copyArray) {
	if (array.length >= max) {
		return array.splice(0, max);
	} else {
		while (array.length < max) {
			array.push(JSON.parse(JSON.stringify(copyArray)));
		}
		return array;
	}
}

export function setInfo1(item) {
	return {
		style: {
			flexDirection: "column",
		},
		children: [
			{
				text: `供应商名称：${item.vendorName}`
			},
			{
				width: null,
				text: `开发单号:${item.developNo || ''}`
			},
			// {
			// 	width: null,
			// 	text: `尚岑编号：${item.accessoryMaterialCode || ''}`
			// },
			// {
			// 	width: null,
			// 	text: `辅料名称：${item.materialDesc || ''}`
			// }
		]
	}
}
export function setInfo2(item) {
	return {
		children: [
			// {
			// 	width: null,
			// 	text: `颜色：${item.colorName}`
			// },
			// {
			// 	width: null,
			// 	text: `规格：${item.standard}`
			// },
			// {
			// 	width: null,
			// }
		]
	}
}

export function setInfo3(item) {
	return {
		style: {
			flexDirection: "column",
			flex: 'none',
			width: '70%',
			height: '91mm'
		},
		children: [
			{
				style: {
					flexDirection: "column",
					height: '30mm',
					flex: 'none'
				},
				children: [
					{
						children: [
							{
								text: `辅料名称：${item.developDesc || ''}`
							},
							{
								text: `颜色：${item.colorDesc}`
							}
						]
					},
					{
						children: [
							{
								text: `供应商物料编号：${item.vendorMaterialCode}` 
							},
							{
								text: `规格：${item.stanard}`
							}
						]
					},
					{
						children: [
							{
								style: {
									width: '30%',
									flex: 'none',
								},
								children: [
									{
										text: `尚岑编号：${item.accessoryMaterialCode || ''}`
									}
								]
							},
							{
								style: {
									width: '70%',
									flexDirection: "column",
									flex: 'none'
								},
								children: [
									{
										children: [
											{
												width: null,
												text: ""
											},
											{
												width: null,
												text: `${0}至${2999}`
											},
											{
												width: null,
												text: `${3000}至${10000}`
											},
											{
												width: null,
												text: `${10000}至${30000}`
											}
										]
									},
									{
										children: [
											{
												width: null,
												text: "总单价"
											},
											{
												width: null,
												text: ((Number(item.rawAmount) + Number(item.price1) + Number(item.transLoss)) * (1 + Number(item.profitPct)/100) * (1 + Number(item.taxRatePct)/100)).toFixed(2)
											},
											{
												width: null,
												text: ((Number(item.rawAmount) + Number(item.price2) + Number(item.transLoss)) * (1 + Number(item.profitPct)/100) * (1 + Number(item.taxRatePct)/100)).toFixed(2)
											},
											{
												width: null,
												text: ((Number(item.rawAmount) + Number(item.price3) + Number(item.transLoss)) * (1 + Number(item.profitPct)/100) * (1 + Number(item.taxRatePct)/100)).toFixed(2)
											}
										]
									}
								]
							}
						]
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: "物料名称"
					},
					{
						width: null,
						text: "材质"
					},
					{
						width: null,
						text: "单位"
					},
					{
						width: null,
						text: "单件用量"
					},
					{
						width: null,
						text: "单价"
					},
					{
						width: null,
						text: "损耗 (%)"
					},
					{
						width: null,
						text: "金额"
					}
				]
			}
		]
	}
}

export function setInfo4(item) {
	return {
		style: {
			height: '91mm'
		},
		render(h, inner) {
			const imgInfo = setImgStyle(item.imgUrl)
			return <div style="width: 91mm;height:91mm;margin: 0 auto;line-height: 91mm;"><img class={imgInfo.class} src={imgInfo.url}></img>;</div>

		}
	}
}

export function setInfo5(item) {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				children: [
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: `${0}至${2999}`
					},
					{
						width: null,
						text: `${3000}至${10000}`
					},
					{
						width: null,
						text: `${10000}至${30000}`
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: "加工单价"
					},
					{
						width: null,
						text: item.price1
					},
					{
						width: null,
						text: item.price2
					},
					{
						width: null,
						text: item.price3
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: "运输损耗包装"
					},
					{
						width: null,
						text: item.lossPackaging
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: "起订量"
					},
					{
						width: null,
						text: "样板周期"
					},
					{
						width: null,
						text: "大货货期"
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: item.minOrderQty
					},
					{
						width: null,
						text: item.sampleDeliveryDate
					},
					{
						width: null,
						text: item.wearDeliveryDate
					}
				]
			}
		]
	}
}

export function setInfo6(item) {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				children: [
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: `${0}至${2999}`
					},
					{
						width: null,
						text: `${3000}至${10000}`
					},
					{
						width: null,
						text: `${10000}至${30000}`
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: "毛利润"
					},
					{
						text: `${item.profitPct}`
					},
					{
						text: `${item.profitPct}`
					},
					{
						text: `${item.profitPct}`
					},
					{
						text: `${item.profitPct}`
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: "税率"
					},
					{
						width: null,
						text: item.taxRatePct
					},
					{
						width: null,
						text: item.taxRatePct
					},
					{
						width: null,
						text: item.taxRatePct
					},
					{
						width: null,
						text: item.taxRatePct
					}
				]
			},
			{
				children: [
					{
						style: {
							height: '13mm',
							flex: 'none',
							width: '100%'
						},
						children: [
							{
								text: `备注： ${item.remark}`
							}
						]
					},
				]
			}

		]
	}
}

export function setInfo7(item) {
	console.log(item)
	return {
		style: {
			flexDirection: "row"
		},
		children: [
			{
				style: {
					flex: 'none',
					width: '10%'
				},
				children: [
					{
						width: null,
						text: "说明"
					}
				]
			},
			{
				style: {
					flexDirection: "column"
				},
				children: [
					{
						width: null,
						text: "1) 此报价为: CNY HKD USD",
						render(h, value) {
							const keys = ['CNY', 'HKD', 'USD']
							const currency = item.currency ? item.currency : ''
							return (
								<div>
									1) 此报价为: &nbsp;
									{keys.map(inner => {
										if (currency.indexOf(inner) > -1) {
											return <span style='margin-right: 2mm;'><input type='checkbox' disabled checked={true}></input>{inner}</span>
										}
										else {
											return <span style='margin-right: 2mm;'><input type='checkbox' ></input>{inner}</span>
										}
									})}
								</div>
							)
						}
					},
					{
						width: null,
						text: "2) 此报价含13%增值税，含省内外运费。"
					},
					{
						width: null,
						text: `3) 此报价有效期为：${item.years}年${item.periods}期，有效期半年`
					},
					{
						width: null,
						text: "4) 产品环保，各项质量指标均达到全国行业标准。"
					},
					{
						width: null,
						text: "5) 绣花类产品需在备注里面填写针数及寸数。"
					}
				]
			}
		]
	}
}

export function setInfo8() {
	return {
		style: {
			flexDirection: "column"
		},
		children: [
			{
				children: [
					{
						width: null,
						text: "报价人:"
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: "审核:"
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: "打印日期:"
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: ""
					}
				]
			},
			{
				children: [
					{
						width: null,
						text: "开发员:"
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: "主任审核:"
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: "经理复核:"
					},
					{
						width: null,
						text: ""
					},
					{
						width: null,
						text: "成控复核"
					},
					{
						width: null,
						text: ""
					}
				]
			}
		]
	}
}
